import { render, staticRenderFns } from "./ModelPreviewTemp.vue?vue&type=template&id=6d6ff3bc&scoped=true"
import script from "./ModelPreviewTemp.vue?vue&type=script&lang=js"
export * from "./ModelPreviewTemp.vue?vue&type=script&lang=js"
import style0 from "./ModelPreviewTemp.vue?vue&type=style&index=0&id=6d6ff3bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6ff3bc",
  null
  
)

export default component.exports